/**
 * RedNedeniNotu.jsx — "Red nedeni: …": the small red line under a rejected document (backlog #737).
 *
 * The company portal's Firma Kartı already wrote this under a rejected company document (#282); the portal's Personel pages did not
 * (a rejected SGK / İSG / Sağlık / KVKK / Mesleki Eğitim card, or a rejected company document tile, only said "Reddedildi"). Same wording
 * as Firma Kartı's tiles (`portal:firmaKart.redNedeni`), so it reads the same everywhere. Renders nothing without a reason.
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function RedNedeniNotu({ neden, className = "mt-2" }) {
  const { t } = useTranslation("portal");
  const metin = typeof neden === "string" ? neden.trim() : "";
  if (!metin) return null;
  return (
    <div className={`text-danger small ${className}`} data-testid="red-nedeni">
      <span className="fw-semibold">{t("firmaKart.redNedeni")}</span> {metin}
    </div>
  );
}
